import React, { Component } from "react";
import { default as ReactSelect } from "react-select";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { isDesktop } from "react-device-detect";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Icon } from "@iconify/react";
import {
    postForgotPasswordEmail,
    generateForgotPasswordOTP,
    resendForgotPasswordOTP,
    verifyForgotPasswordOTP,
    postForgotPassword,
    checkForgotPassword,
    postForgotPasswordOTP,
} from "../../store/ducks/forgotPassword/actions";
import { generateSMSOTP, verifySMSOTP, resendOTP } from "../../store/ducks/profile/actions";
import { getCountry } from "../../store/ducks/home/actions";
import PasswordInput from "../../components/Input/PasswordInput/PasswordInput";
import { formValidation } from "../../hoc/Shared/utility";

let countryList = [];
let contact_no_min_limits = 9;
let contact_no_max_limits = 10;

export class ChangeNewPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPwd: false,
            newPassword: "",
            confirm_password: "",
            showPwdConfirmation: false,
            errorMsg: [],
        };
    }
    componentDidMount() {
        this.props.getCountry();

        formValidation("forgot_password_form");
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { t } = this.props;
        if (nextProps.countryData !== this.props.countryData) {
            this.setState({
                referral: sessionStorage.getItem("referralCode"),
            });
            countryList = [];

            let countryData = nextProps.countryData.country;

            Object.keys(countryData).map((item, i) => {
                countryList.push({
                    // label: countryData[item].dialCode + "(" + countryData[item].countryName + ")",
                    name: countryData[item].countryName,
                    value: countryData[item].dialCode,
                    phone: countryData[item].dialCode,
                    code: countryData[item].countryShortCode,
                    image: countryData[item].countryShortCode + ".webp",
                });

                return [countryList];
            });

            this.setState({ loading: false });
        }

        if (nextProps.post_forgot_password_email_data !== this.props.post_forgot_password_email_data) {
            const { t } = this.props;
            if (nextProps.post_forgot_password_email_data.responseCode === 200) {
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                    title: t("global.success"),
                    text: t("forgot-password.success"),
                    // icon: nextProps.post_forgot_password_email_data.msgType,
                    icon: "success",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.setState({ showSendSuccessMessage: true });
                    }
                });
            } else if (nextProps.post_forgot_password_email_data.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    errorMsg: nextProps.post_forgot_password_email_data.message.input_error || [],
                    formError: true,
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                Swal.fire({
                    iconHtml: !isDesktop ? '<img src="https://api.iconify.design/fa6-solid:face-sad-tear.svg?color=%23b0b0b0">' : "",
                    title: t("global.sorry"),
                    text: t("forgot-password.error"),
                    // icon: nextProps.post_forgot_password_email_data.data.msgType,
                    icon: "error",
                    confirmButtonText: t("global.ok"),
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sorry",
                              icon: "swal-sorry-icon",
                          }
                        : [],
                });
            }
        }

        if (nextProps.post_forgot_password_data !== this.props.post_forgot_password_data) {
          if (nextProps.post_forgot_password_data.responseCode === 200) {
              Swal.fire({
                  iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : '',
                  title: t("global.success"),
                  text: nextProps.post_forgot_password_data.message,
                  // icon: nextProps.post_forgot_password_data.msgType,
                  icon: 'success',
                  confirmButtonText: t("global.ok"),
                  customClass: (!isDesktop) ? {
                      container: 'swal-mobile-container sucess',
                      icon: 'swal-success-icon'
                  } : [],
              }).then((result) => {
                  if (result.isConfirmed) {
                      this.props.history.push("/");
                  }
              });
          } else if (nextProps.post_forgot_password_data.responseCode === 422) {
            this.setState({ loading: false });
            Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : '',
                title: t("global.failed"),
                text: nextProps.post_forgot_password_data.message,
                // icon: nextProps.post_forgot_password_data.data.msgType,
                icon: "error",
                confirmButtonText: t("global.ok"),
                customClass: (!isDesktop) ? {
                    container: "swal-mobile-container failed",
                    icon: "swal-failed-icon", 
                } : [],
            });
          } else {
              this.setState({ loading: false });
              Swal.fire({
                  iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : '',
                  title: t("global.failed"),
                  text: nextProps.post_forgot_password_data.data.message[0],
                  // icon: nextProps.post_forgot_password_data.data.msgType,
                  icon: "error",
                  confirmButtonText: t("global.ok"),
                  customClass: (!isDesktop) ? {
                      container: "swal-mobile-container failed",
                      icon: "swal-failed-icon", 
                  } : [],
              });
          }
      }

      if (nextProps.post_forgot_password_otp_data !== this.props.post_forgot_password_otp_data) {
          if (nextProps.post_forgot_password_otp_data.responseCode === 200) {
              Swal.fire({
                  iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : '',
                  title: t("global.success"),
                  text: nextProps.post_forgot_password_otp_data.message,
                  // icon: nextProps.post_forgot_password_otp_data.msgType,
                  icon: 'success',
                  confirmButtonText: t("global.ok"),
                  customClass: (!isDesktop) ? {
                      container: 'swal-mobile-container sucess',
                      icon: 'swal-success-icon'
                  } : [],
              }).then((result) => {
                  if (result.isConfirmed) {
                      this.props.history.push("/");
                  }
              });
          } else if (nextProps.post_forgot_password_otp_data.responseCode === 422) {
              this.setState({
                  loading: false,
                  touched: true,
                  error_message: nextProps.post_forgot_password_otp_data.message,
              });
              Swal.close();
          
          } else {
              this.setState({ loading: false });
              Swal.fire({
                  iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ffffff">' : '',
                  title: t("global.failed"),
                  text: nextProps.post_forgot_password_otp_data.data.message[0],
                  // icon: nextProps.post_forgot_password_otp_data.data.msgType,
                  icon: "error",
                  confirmButtonText: t("global.ok"),
                  customClass: (!isDesktop) ? {
                      container: "swal-mobile-container failed",
                      icon: "swal-failed-icon", 
                  } : [],
              });
          }
      }

        return true;
    }
    toggleShowPwd = () => {
        this.setState({
            showPwd: !this.state.showPwd,
        });
    };

    toggleShowConfirmPwd = () => {
        this.setState({
            showPwdConfirmation: !this.state.showPwdConfirmation,
        });
    };

    handleConfirmPassword = (e) => {
        this.setState({
            confirm_password: e.target.value,
        });
    };

    onChangeNewPasswordHandler = (e) => {
        this.setState({
            newPassword: e.target.value,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    submitForgotPasswordOTPHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                const data = {};

                data.contact_number = this.props.match.params.token;
                data.password = this.state.newPassword;
                data.confirm_password = this.state.confirm_password;

                this.props.postForgotPasswordOTP(data);
            }
        });
    };

    submitForgotPasswordHandler = (event) => {
        event.preventDefault();

        const { t } = this.props;

        Swal.fire({
            iconHtml: !isDesktop ? '<img src="https://api.iconify.design/ic:outline-question-mark.svg?color=%23ffffff">' : "",
            title: t("global.confirmation"),
            text: t("global.would-you-like-to-proceed") + "?",
            icon: "warning",
            confirmButtonText: t("global.confirm"),
            showDenyButton: true,
            denyButtonText: t("global.cancel"),
            customClass: !isDesktop
                ? {
                      container: "swal-mobile-container confirmation",
                      icon: "swal-confirmation-icon",
                  }
                : [],
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading();
                    },
                });

                const data = {};

                data.token = this.props.match.params.token;
                data.password = this.state.newPassword;
                data.confirm_password = this.state.confirm_password;

                this.props.postForgotPassword(data);
            }
        });
    };

    render() {
        const { t } = this.props;
        const icon = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        const logo = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));
        return (
            <Auxiliary>
                {isDesktop ? (
                    <section className="logreg-wrap">
                        <div className="logreg-logo">
                            <img src={logo["x33-logo.png"]} alt="logo" />
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
                            </div>
                            <div className="col-6">
                                <div className="logreg-body-wrap">
                                    <h4 className="mb-4">{t("change-password.change-password")}</h4>
                                    <form
                                        className="forms-col needs-validation"
                                        method="post"
                                        name="email_address_form"
                                        id="forgot_password_form"
                                        onSubmit={isNaN(this.props.match.params.token) ? this.submitForgotPasswordHandler : this.submitForgotPasswordOTPHandler  }
                                        noValidate
                                    >
                                        <div>
                                            <small>{t("change-password.new-password")}</small>
                                            <div className="input-group left has-validation">
                                                <span className="input-group-text left-icon">
                                                    <img src={icon["icon-password.png"]} alt="username icon" />
                                                </span>
                                                <PasswordInput
                                                    showPwd={this.state.showPwd}
                                                    className={`form-control no-border-r}`}
                                                    // className={`form-control no-border-r ${this.props.errorMsg.password && "was-validated is-invalid "}`}
                                                    id="password"
                                                    autoComplete="off"
                                                    placeholder={t("change-password.new-password")}
                                                    onChange={this.onChangeNewPasswordHandler}
                                                    required
                                                    requiredMessage={t("validation.required")}
                                                    value={this.state.newPassword}
                                                    // errorMsg={this.state.errorMsg.password || "213123"}
                                                    // formError={true}
                                                    format={
                                                        <button type="button" className=" right-icon" onClick={this.toggleShowPwd}>
                                                            {this.state.showPwd ? <img src={icon["eye.png"]} alt="show pwd" /> : <img src={icon["close-eye.png"]} alt="hide pwd" />}
                                                        </button>
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <small>{t("change-password.confirm-password")}</small>
                                            <div className="input-group left has-validation">
                                                <span className="input-group-text left-icon">
                                                    <img src={icon["icon-password.png"]} alt="username icon" />
                                                </span>
                                                <PasswordInput
                                                    showPwdConfirmation={this.state.showPwdConfirmation}
                                                    // className={`form-control no-border-r ${this.props.errorMsg.confirm_password && "was-validated is-invalid "}`}
                                                    className={`form-control no-border-r}`}
                                                    id="confirm_password"
                                                    autoComplete="off"
                                                    placeholder={t("change-password.confirm-password")}
                                                    required
                                                    requiredMessage={t("validation.required")}
                                                    value={this.state.confirm_password}
                                                    oldPassword={this.state.newPassword}
                                                    confirmpassword={this.state.confirm_password}
                                                    onChange={this.handleConfirmPassword}
                                                    format={
                                                        <button type="button" className=" right-icon" onClick={this.toggleShowConfirmPwd}>
                                                            {this.state.showPwdConfirmation ? (
                                                                <img src={icon["eye.png"]} alt="show pwd" />
                                                            ) : (
                                                                <img src={icon["close-eye.png"]} alt="hide pwd" />
                                                            )}
                                                        </button>
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <button
                                            className="btn btn-gradient-blue rounded-pill mt-3"
                                            type="submit"
                                            disabled={this.state.newPassword === "" && this.state.confirm_password === "" ? true : false}
                                        >
                                            {t("global.submit")}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <section className="logreg-wrap">
                        <div className="logreg-logo">
                            <img src={logo["x33-logo.png"]} alt="logo" />
                        </div>
                        <div className="pt-4">
                            <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
                        </div>
                        <div className="logreg-content w-shadow">
                            <div className="logreg-body-wrap forget-pass text-start">
                                <h4 className="mb-4">{t("change-password.change-password")}</h4>
                                <form
                                    className="forms-col needs-validation"
                                    method="post"
                                    name="email_address_form"
                                    id="forgot_password_form"
                                    onSubmit={isNaN(this.props.match.params.token) ? this.submitForgotPasswordHandler : this.submitForgotPasswordOTPHandler  }
                                    noValidate
                                >
                                    <div>
                                        <small>{t("change-password.new-password")}</small>
                                        <div className="input-group left has-validation">
                                            <span className="input-group-text left-icon">
                                                <img src={icon["icon-password.png"]} alt="username icon" />
                                            </span>
                                            <PasswordInput
                                                showPwd={this.state.showPwd}
                                                className={`form-control no-border-r}`}
                                                // className={`form-control no-border-r ${this.props.errorMsg.password && "was-validated is-invalid "}`}
                                                id="password"
                                                autoComplete="off"
                                                placeholder={t("change-password.new-password")}
                                                onChange={this.onChangeNewPasswordHandler}
                                                required
                                                requiredMessage={t("validation.required")}
                                                value={this.state.newPassword}
                                                // errorMsg={this.props.errorMsg.password || ""}
                                                // formError={this.props.formError}
                                                format={
                                                    <button type="button" className=" right-icon" onClick={this.toggleShowPwd}>
                                                        {this.state.showPwd ? <img src={icon["eye.png"]} alt="show pwd" /> : <img src={icon["close-eye.png"]} alt="hide pwd" />}
                                                    </button>
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <small>{t("change-password.confirm-password")}</small>
                                        <div className="input-group left has-validation">
                                            <span className="input-group-text left-icon">
                                                <img src={icon["icon-password.png"]} alt="username icon" />
                                            </span>
                                            <PasswordInput
                                                showPwdConfirmation={this.state.showPwdConfirmation}
                                                // className={`form-control no-border-r ${this.props.errorMsg.confirm_password && "was-validated is-invalid "}`}
                                                className={`form-control no-border-r ${this.state.password === "" ? "is-invalid is-invalid" : "is-valid is-valid"}`}
                                                id="confirm_password"
                                                autoComplete="off"
                                                placeholder={t("change-password.confirm-password")}
                                                required
                                                requiredMessage={t("validation.required")}
                                                value={this.state.confirm_password}
                                                oldPassword={this.state.newPassword}
                                                confirmpassword={this.state.confirm_password}
                                                onChange={this.handleConfirmPassword}
                                                format={
                                                    <button type="button" className=" right-icon" onClick={this.toggleShowConfirmPwd}>
                                                        {this.state.showPwdConfirmation ? (
                                                            <img src={icon["eye.png"]} alt="show pwd" />
                                                        ) : (
                                                            <img src={icon["close-eye.png"]} alt="hide pwd" />
                                                        )}
                                                    </button>
                                                }
                                            />
                                        </div>
                                    </div>
                                    <button className="btn btn-gradient-blue rounded-pill mt-3" type="submit" disabled={this.state.newPassword === "" && this.state.confirm_password === "" ? true : false}>
                                        {t("global.submit")}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </section>
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { forgotPassword, profile } = state;

    return {
        post_forgot_password_email_data: forgotPassword.post_forgot_password_email_data,
        currentUser: state.currentUser.data,
        generate_sms_otp_result: profile.generate_sms_otp_result,
        verify_sms_otp_result: profile.verify_sms_otp_result,
        resend_otp_result: state.profile.resend_otp_result,
        countryData: state.home.country_data,
        generate_forgot_password_otp_data: forgotPassword.generate_forgot_password_otp_data,
        resend_forgot_password_otp_data: forgotPassword.resend_forgot_password_otp_data,
        verify_forgot_password_otp_data: forgotPassword.verify_forgot_password_otp_data,
        post_forgot_password_data: forgotPassword.post_forgot_password_data,
        check_forgot_password_data: forgotPassword.check_forgot_password_data,
        post_forgot_password_otp_data: forgotPassword.post_forgot_password_otp_data,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = {
    postForgotPasswordEmail,
    generateSMSOTP,
    verifySMSOTP,
    resendOTP,
    getCountry,
    generateForgotPasswordOTP,
    resendForgotPasswordOTP,
    verifyForgotPasswordOTP,
    checkForgotPassword,
    postForgotPassword,
    postForgotPasswordOTP,
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(ChangeNewPassword));
